// export const SKETCH_URI = 'sketch';
export const SKETCH_URI = 'template';
export const SKETCH_URI_PDF = `${SKETCH_URI}/pdf`;

export const GET_SKETCH_PDF = `${SKETCH_URI}/pdf`;
export const DUPLICATE_SKETCH_URI = `${SKETCH_URI}/copy`;
export const SET_SKETCH_PREVIEW_URI = `${SKETCH_URI}/preview`;
